import { Injectable } from '@angular/core';
import { API_END_POINT } from '@app/core/constants/app-constant';
import { ApiResponse } from '@app/shared/models/ApiResponse';
import { ApiService } from '../api.service';

@Injectable({
  providedIn: 'root',
})
export class ApiJobsService {
  constructor(private apiSvc: ApiService) {}
  getJobStatus(code: string, locationId: string): Promise<ApiResponse> {
    // return this.apiSvc.get(`releaseCode/${code}?id=${locationId}`);
    return this.apiSvc.get(API_END_POINT.getJobStatus(code, locationId));
  }

  getJobs(customerID: string, userName: string): Promise<ApiResponse> {
    // return this.apiSvc.get(`printJobs?id=${customerID}&userName=${userName}`);
    return this.apiSvc.get(API_END_POINT.getJobs(customerID, userName));
  }
}
